module.exports = __webpack_public_path__ + "img/Angriffstruppführer.be27543b.svg";